import React from 'react';
import { Box } from '@mui/material';
import { Routes, Route } from 'react-router-dom';
import Start from './pages/Start';

// One tier only: everything is behind EVE SSO plus the corp/alliance
// allowlist, which is what PRODUCT.md has always said this app is. The
// earlier public/anonymous tier (public system pages, anonymous vault share
// links) has been removed.
//
// Deep links still work: `Start` captures whatever path was requested and
// hands it to the SSO flow as `returnTo`, so pasting /system/J224754 into
// corp chat sends a member to the login screen and then straight on to that
// system's page. The route table itself lives in Gate.tsx, past the gate.
//
// WormholeVoid (the starfield/nebula backdrop) is scoped to Start.tsx's own
// pre-auth states — the flat EVE-HUD direction used everywhere else has no
// ambient decoration behind its panels.
const App: React.FC = () => (
  <Box sx={{ position: 'relative', zIndex: 1 }}>
    <Routes>
      <Route path="*" element={<Start />} />
    </Routes>
  </Box>
);

export default App;
